import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

const heatmapFormInitialStyleSelector = (state: AppState) => state.frontendState.mapTools.heatmap.initialStyle;
export const useHeatmapFormInitialStyle = () => useSelector(heatmapFormInitialStyleSelector);
